module.exports = {
	"LANGUAGE": "Taal",
	"HDR-obpa_fulltext_score": "Score",
	"HDR-obpa_name": "Naam",
	"HDR-obpa_fulltext_summary": "Samenvatting",
	"QUERY LIMIT REACHED": "Er zijn meer resultaten dan wat wordt weergegeven. Beperk uw zoekcriteria.",
	"NO DOCUMENTS FOUND": "Geen documenten gevonden.",
	"OPEN IN NEW WINDOW": "Openen in nieuw venster",
	"DOWNLOAD NATIVE": "Downloaden in oorspronkelijk formaat",
	"CLOSE": "Sluiten",
	"SEARCH TYPE": "Type zoekopdracht",
	"DOCUMENT TYPE": "Documenttype",
	"SEARCH TERM": "Zoekterm",
	"SEARCH": "Zoeken",
	"RESET": "Reset",
	"DATE": "Datum",
	"FROM DATE": "Vanaf datum",
	"TO DATE": "Tot datum",
	"LOADING": "Laden...",
	"RETRY": "Opnieuw proberen",
	"ERROR": "Fout!",
	"ERROR: QUERIES": "Niet in staat om de lijst met zoektypen op te vragen.",
	"ERROR: DOCTYPES": "De lijst met documentsoorten kan niet worden opgehaald.",
	"ERROR: KEYWORDS": "De lijst met zoekvelden kan niet worden opgehaald.",
	"ERROR: DOCUMENTS": "Niet in staat om de gevraagde zoekopdracht uit te voeren.",
	"FORM: INVALID FULLTEXT": "Veld moet ten minste {{chars}} karakters lang zijn.",
	"FORM: INVALID DATE SHORT": "Formaat: {{format}} .",
	"FORM: REQUIRED KEYWORD": "Veld is verplicht.",
	"FORM: INVALID NUMERIC": "Het veld moet een aantal van maximaal {{digits}} cijfers bevatten.",
	"FORM: INVALID DATE": "Veld moet het formaat volgen {{format}} .",
	"FORM: INVALID CURRENCY": "Veld moet een geldige valutawaarde hebben.",
	"FORM: INVALID FLOAT": "Het veld moet een nummer zijn.",
	"FORM: INVALID LENGTH": "Het veld mag maximaal {{chars}} tekens lang zijn.",
	"FORM: ERRORS": "Er staan fouten in het formulier.",
	"FORM: noDate": "Er moet een datumbereik worden gespecificeerd.",
	"FORM: noKeyword": "Ten minste één veld moet worden gespecificeerd.",
	"FORM: noDateOrKeyword": "Een datumbereik OF Ten minste één veld moet worden gespecificeerd.",
	"FORM: noDateAndKeyword": "Een datumbereik EN ten minste één veld moet worden gespecificeerd."
};


//////////////////
// WEBPACK FOOTER
// ./src/app/shared/i18n/json/nl.json
// module id = 358
// module chunks = 0